export enum RoutesEnum {
  TransferReview = 'transfer-review',
  InitiateTransfer = 'initiate-transfer',
  ParticipantIds = 'participant-ids',
  Root = 'account-transfers',
}
